import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AbstractRtpSettlementService } from '../abstraction/abstract.rtp-settlement.service';
import { IRtpSettlementTransaction } from '../../interfaces/settlement/rtp-settlement-transaction.interface';

@Injectable({
  providedIn: 'root',
})
export class RtpSettlementService extends AbstractRtpSettlementService {
  controller = `/manager/rtp/settlementTransactions`;
  urlGetAccountActivityRespondentTransaction = `${environment.apiUrl}${this.controller}/getsettlementtransactions`;

  constructor(private http: HttpClient) {
    super();
  }

  override getTransactionsByRespondentAndCycle(
    respondentRtn: string,
    cycleDate: string,
    reconWindowId: number
  ): Promise<IRtpSettlementTransaction[] | undefined> {
    return this.http
      .get<IRtpSettlementTransaction[]>(
        `${this.urlGetAccountActivityRespondentTransaction}/${respondentRtn}/${cycleDate}/${reconWindowId}`
      )
      .toPromise();
  }
}
